import { ActivityBuilderModal } from 'approot/activity-builder/activity-builder-modal';
import { PrimaryButton } from 'approot/shared/styles/buttons';
import Text from 'approot/shared/styles/typography/text';
import ImageContentWomanWithExclamationMark from 'approot/shared/images/content/image-content-woman-with-exclamation-mark';
import { Box } from 'approot/shared/design-system/box/box.style';

const StudentClosedAssignmentModal = ({ onClose }: { onClose: () => void }) => {
  return (
    <ActivityBuilderModal
      isVisible
      title="Your teacher closed this assignment"
      headerTitle="Your teacher closed this assignment"
      size={470}
      onClose={onClose}
      actions={<PrimaryButton onClick={onClose}>Ok</PrimaryButton>}
    >
      <Box
        $flexDirection="column"
        $alignItems="center"
        $justifyContent="center"
      >
        <Box $marginBottom={24}>
          <ImageContentWomanWithExclamationMark width={120} />
        </Box>
        <Text $marginBottom={8} $align="center">
          Your work is saved. You can look at it.
          <br />
          You can't change your answers.
        </Text>
      </Box>
    </ActivityBuilderModal>
  );
};

export default StudentClosedAssignmentModal;
